﻿import "../../utilities/disable";
import { IRemoteHandler, IRemoteOptions } from "./remote";

export class NestedAnchorRemoteHandler implements IRemoteHandler {
  public handle($element: JQuery, options: IRemoteOptions): boolean {
    // In this handler we check if the targetted element is an anchor with
    //   href, but not the remote attribute. In these cases we don't call
    //   `event.preventDefault()` and let the browser handle the event as
    //   normal. We return true though so we prevent other handers from taking
    //   any actions.
    return $element.isEnabled() && this.targetIsAnchor(options.$target);
  }

  private targetIsAnchor($target: JQuery): boolean {
    if (!$target || $target.length == 0)
      return false;

    return $target.is('a')
      && !$target.is('[data-remote]')
      && $target.attr('href') != undefined;
  }
}
